var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/system';
import { useDinPlayerContext } from 'hx-din-test-2';
import { StartButton } from 'hx-ui';
import { useManualPreloadImages } from 'hx-util';
import { useNavigate } from 'react-router-dom';
import { pageImages } from '@/pages/images';
import { alpha } from '@mui/material/styles';
import { sendScrollIntoView } from '@/helpers/send-scroll-into-view.helper';
import { IsolatedAnimatedCircles } from './isolated-animated-circles.component';
var imagesToPreload = {
    desktop: __spreadArray([], Object.values(pageImages), true),
};
export function WelcomePageLayoutContent() {
    var loadImages = useManualPreloadImages(imagesToPreload).loadImages;
    var theme = useTheme();
    var navigate = useNavigate();
    var _a = useDinPlayerContext(), initialize = _a.initialize, progress = _a.state.progress;
    function handleStartClick() {
        loadImages();
        initialize().then(function () { return navigate('/setup'); });
        sendScrollIntoView();
    }
    return (_jsx("main", __assign({ className: "items-center py-24" }, { children: _jsx(StartButton, __assign({ onClick: handleStartClick, progress: progress, color: theme.palette.secondary.main, GraphicElement: IsolatedAnimatedCircles, graphicElementProps: {
                colorTransform: function (index) {
                    var base = theme.palette.secondary.main;
                    var colors = [
                        base,
                        alpha(base, 0.7),
                        alpha(base, 0.4),
                        alpha(base, 0.1),
                    ];
                    return colors[index % colors.length];
                },
                count: 4,
                opacity: 1,
            }, buttonStyles: {
                fontSize: 'x-large',
                color: theme.palette.common.white,
                minWidth: '7.25rem',
                minHeight: '7.25rem',
                textTransform: 'uppercase',
            } }, { children: _jsx("span", __assign({ className: "text-lg" }, { children: "D\u00C9MARRER" })) })) })));
}
